import { motion } from "framer-motion";
import { ShieldCheck, Gamepad2, Rocket, BadgeCheck } from "lucide-react";
import { MEDIA } from "../data";
import { useLang } from "../LanguageContext";

const ICONS = [ShieldCheck, Gamepad2, Rocket, BadgeCheck];

const fade = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut", delay: i * 0.08 } }),
};

export const Offer = () => {
  const { t } = useLang();
  return (
    <section id="oferta" className="bg-[#0A0A0A] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="relative order-2 lg:order-1"
          >
            <div className="aspect-[4/3] overflow-hidden rounded-sm border border-white/10">
              <img src={MEDIA.offer} alt="Pierwsze spotkanie z dronem" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="absolute -bottom-5 -right-3 sm:right-6 bg-[#E02020] text-white px-6 py-4 rounded-sm">
              <span className="block font-display text-3xl font-bold leading-none">{t.offer.badgeTop}</span>
              <span className="text-xs uppercase tracking-wider">{t.offer.badgeBottom}</span>
            </div>
          </motion.div>

          <div className="order-1 lg:order-2">
            <p className="font-body text-xs font-bold uppercase tracking-[0.22em] text-[#E02020] mb-4">{t.offer.overline}</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
              {t.offer.title}
            </h2>
            <p className="mt-5 text-[#A3A3A3] leading-relaxed">{t.offer.intro}</p>

            <div className="mt-8 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
              {t.offer.items.map((it, i) => {
                const Icon = ICONS[i];
                return (
                  <motion.div
                    key={i}
                    custom={i}
                    variants={fade}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    data-testid={`offer-item-${i}`}
                    className="bg-[#0A0A0A] p-6"
                  >
                    <Icon className="text-[#E02020] mb-3" size={26} />
                    <h3 className="font-display font-semibold text-white text-base mb-1.5">{it.title}</h3>
                    <p className="text-sm text-[#A3A3A3] leading-relaxed">{it.text}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
